export default __webpack_public_path__ + "static/media/ww6.1599fb89.jpg";